import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { List } from 'immutable';
import { IRouter } from '../../interfaces/router.interface';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';
import { map, shareReplay } from 'rxjs/operators';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { Observable } from 'rxjs';
import { FeaturesDataStore } from '../../../features-data/features-data.store';

@Component({
  selector: 'app-horizontal-nav',
  templateUrl: './horizontal-nav.component.html',
  styleUrls: ['./horizontal-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalNavComponent implements OnInit {
  @Input() navItems: List<IRouter>;

  @Output() onRoute: EventEmitter<void> = new EventEmitter<void>();

  isIaNavEnabled$: Observable<boolean>;
  chevronIcon: IIcon;

  constructor(private _featuresDataStore: FeaturesDataStore) {}

  ngOnInit() {
    this.isIaNavEnabled$ = this._featuresDataStore.getFeatureToggles().pipe(
      map((toggles) => toggles.isAllAccess(Toggles.KEYS.IA_NAV_EXPERIMENT)),
      shareReplay(1)
    );

    this.chevronIcon = {
      name: 'chevron-right',
      size: IconSizesEnum.small,
    };
  }
}
